.channelMetadata {
  font-size: 14px;
}

.title {
  margin-bottom: 1rem;
}

.metadataValue {
  margin-left: 0.25rem;
  font-weight: var(--font-weight-light);
}
